import { Component, EventEmitter, Inject, Input, Output, OnInit, AfterViewInit } from 'ng-metadata/core';
import './action-trigger.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentActionTrigger
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - The text that the trigger will display
 * @param {string} [link] - The link that the trigger will have (is optional)
 * @param {expression} [on-click] - What to do when the trigger is clicked
 * @description
 * `mw-content-document-action-trigger` is a component that is responsible for triggering specific events on click
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-action-trigger text="Hello" link="http:www.google.com" on-click="someHandler()"> </mw-content-document-action-trigger>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-action-trigger',
    template: `
        <a ng-if="::$ctrl.hasLink"
            href="{{::$ctrl.link}}"
            target="_blank"
            class="mw-content-document-action-trigger"
            ng-class="{ 'mw-content-document-action-trigger--active': $ctrl.isActive, 'mw-content-document-action-trigger--interactive': $ctrl.isInteractive }"
            ng-click="$ctrl.handleActionTriggerClick($event)" translate>
            {{::$ctrl.text}}
        </a>
        <span ng-if="::!$ctrl.hasLink"
            ng-click="$ctrl.handleActionTriggerClick($event)"
            class="mw-content-document-action-trigger"
            ng-class="{ 'mw-content-document-action-trigger--active': $ctrl.isActive, 'mw-content-document-action-trigger--interactive': $ctrl.isInteractive }"
            translate>
            {{::$ctrl.text}}
        </span>
    `
})

export class ActionTriggerComponent implements OnInit {
    @Input('<') isActive: boolean = false;
    @Input('<') text: string;
    @Input('<') link: string;

    isInteractive: boolean = false;
    hasLink: boolean = false;
    hasClickHandler: boolean = false;

    @Output() onClick = new EventEmitter<any>();

    constructor(
        @Inject('$element') private $element: ng.IRootElementService
    ) {
        'ngInject';
    }

    ngOnInit() {
        if (this.link) {
            this.hasLink = true;
        }

        if (this.$element.attr('on-click')) {
            this.hasClickHandler = true;
        }

        this.isInteractive = this.hasLink || this.hasClickHandler;
    }

    handleActionTriggerClick(event) {
        // This function disabled event bubbling for a click on the span tag.
        // Prior to this fix, when this component is used within fairhair web,
        // a click on the span tag was causing navigation. Calling stopPropagation
        // on the event stops that action from bubbling and therefore preventing
        // the navigation from taking place.
        event.stopPropagation();

        if (this.hasClickHandler) {
            this.onClick.emit(event);
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/action-trigger/action-trigger.component.ts